const generateComparatorGroupValues = (referenceMap) => {
    let partOfRelationshipReference = {
        "reference": "Composition/" + referenceMap.compositionId,
        "type": "Composition",
        "display": referenceMap.compositionTitle
    };
    if (referenceMap?.populationReference && referenceMap.comparatorDescriptionReference) {
        return {
            "combinationMethod": "all-of",
            "characteristic": [
                {
                    "description": "inclusion in " + referenceMap.populationReference.display,
                    "code": { "text": "Member of" },
                    "valueReference": referenceMap.populationReference,
                    "exclude": false
                },
                {
                    "description": "exposed to " + referenceMap.comparatorDescriptionReference.display,
                    "code": { "text": "Exposed to" },
                    "valueReference": referenceMap.comparatorDescriptionReference,
                    "exclude": false
                }
            ],
            "partOfRelationshipReference": partOfRelationshipReference
        }
    } else if (referenceMap?.populationReference) {
        return {
            "combinationMethod": "all-of",
            "characteristic": [
                {
                    "description": "inclusion in " + referenceMap.populationReference.display,
                    "code": { "text": "Member of" },
                    "valueReference": referenceMap.populationReference,
                    "exclude": false
                },
                {
                    "description": "exposed to the comparator",
                    "code": { "text": "Exposed to" },
                    "valueCodeableConcept": { "text": "the comparator" },
                    "exclude": false
                }
            ],
            "partOfRelationshipReference": partOfRelationshipReference
        };
    }
};

export default generateComparatorGroupValues;